export default "__VITE_ASSET__BNeWh$zp__"